//Hex global footer
/******************************************************************/
$(document).ready(function(){
    //code for nested accordion
    $(document).on("click",".footer-grid__title--accordion-head",function(){
      $(this).parents('.footer-grid__list-conatiner').find('.active_head').removeClass('active_head');
      $(this).toggleClass('active_head');
    });
    $(document).on("click",".footer-grid__title--accordion-head.active_head",function(){
      $(this).removeClass('active_head');
    });
  
    //code for nested accordion capability
    $(document).on("click",".footer-grid__cell-wrapper",function(){
      $(this).parents('.footer-grid').find('.active_head_mobile').removeClass('active_head_mobile');
      $(this).parents('.footer-grid__box').toggleClass('active_head_mobile');
    });
    $(document).on("click",".footer-grid__box.active_head_mobile .footer-grid__cell-wrapper",function(){
      $(this).parents('.footer-grid__box').removeClass('active_head_mobile');
      $(this).parents('.footer-grid__list-conatiner').find('.active_head').removeClass('active_head');
    });
  
});